import { gql } from 'apollo-boost';

export const QUERY_VENDOR_OPPORTUNITY = gql`
  query VendorOpportunityPublic($voId: ID!) {
    vendorOpportunityPublic(id: $voId) {
      vendorOpportunityId
      dynamicsVendorOpportunityId
      vendorProfileId
      potentialCustomer {
        id
        dynamicsAccountId
        name
      }
      salesManager {
        id
        fullName
        dynamicsContactId
        firstName
        lastName
        email
        phoneNumber
        title
      }
      salesRepresentative {
        id
        fullName
        dynamicsContactId
        firstName
        lastName
        email
        phoneNumber
        title
      }
      financeManager {
        id
        email
        dynamicsContactId
        firstName
        lastName
        fullName
        phoneNumber
        title
      }
      equipments {
        id
        year
        mileage
        make
        model
        newUsed
        retailPrice
        classType
        serialNumberVin
      }
    }
  }
`;
